import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss'

Vue.use(ElementUI);

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000


const createService = baseURL => {
    const service = axios.create({
        baseURL,
        timeout: 50000
    });

    return service
}

// 正式库
const baseFetch = createService('http://zjeyapi.ypaiban.com/api');   // 7878
const myFetch = createService('http://zjeyapi2.ypaiban.com/api');   // 7879

// 测试库
// const baseFetch = createService('http://zjeydawx.ypaiban.com/api');
// const myFetch = createService('http://zjeydawx2.ypaiban.com/api');

Vue.prototype.baseFetch = baseFetch
Vue.prototype.myFetch = myFetch

new Vue(
    {
        router,
        render: h => h(App)
    }
).$mount('#app')
